import { Currency } from '../../../models/serializable/currency';
import { GenericOrder } from '../../../models/serializable/orders/generic-order';
import { GenericOrderEntry } from '../../../models/serializable/orders/generic-order-entry';
import { Price } from '../../../models/serializable/price';
import { GenericOrderDiscountBreakdownEntry } from '../discount-breakdown';
import { GenericOrderFeeBreakdownEntry } from '../fee-breakdown';

export abstract class IGenericOrderPaymentHelperAdapter {
  abstract get orderEntryTypeId(): string;

  abstract getCurrency(order: GenericOrder, orderEntry: GenericOrderEntry): Currency | null;
  abstract calculateDiscountBreakdown(order: GenericOrder, orderEntry: GenericOrderEntry, orderEntryIndex: number): GenericOrderDiscountBreakdownEntry[] | null;
  abstract calculateFeeBreakdown(order: GenericOrder, orderEntry: GenericOrderEntry, orderEntryIndex: number): GenericOrderFeeBreakdownEntry[] | null;
  abstract calculateCheckoutPrice(order: GenericOrder, orderEntry: GenericOrderEntry): Price | null;
  abstract calculateIncome(order: GenericOrder, orderEntry: GenericOrderEntry): Price | null;
  abstract calculateIncomeWithoutDiscount(order: GenericOrder, orderEntry: GenericOrderEntry): Price | null;
  abstract calculateDiscount(orderEntry: GenericOrderEntry): Price | null;
  abstract calculateCheckoutPriceForDiscountProvider(orderEntry: GenericOrderEntry): Price | null;
  abstract canCreateRefund(order: GenericOrder, orderEntry: GenericOrderEntry): boolean | null;
  abstract calculateMaxSimulatedRefund(order: GenericOrder, orderEntry: GenericOrderEntry, options: { includeFee: boolean }): Price | null;
}
